import './css/App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useEffect } from 'react'
import Header from './js/header_components/Header'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './js/page_components/Home'
import InstagramSlider from './js/page_components/InstagramSlider'
import Gallery from './js/page_components/Gallery'
import Gallery2008 from './js/page_components/Gallery2008'
import Gallery2009 from './js/page_components/Gallery2009'
import Gallery2012 from './js/page_components/Gallery2012'
import Gallery2013 from './js/page_components/Gallery2013'
import Gallery2015 from './js/page_components/Gallery2015'
import Subheader from './js/header_components/Subheader'
import SponsorsLeaderboard from './js/page_components/SponsorLeaderboard'
import AboutSection from './js/page_components/AboutSection'
import NotFound from './js/page_components/NotFound'
import UpcomingMatches from './js/page_components/UpcomingMatches'
import Slider from './js/header_components/Slider'
import Footer from './js/page_components/Footer'
import ANCLTeam from './js/team_details/ANCLTeam'
import ANCLSeries from './js/page_components/ANCLSeries'
import SinglePlayerDetail from './js/team_details/SinglePlayerDetail'
import ANCLSeriesDetails from './js/page_components/ANCLSeriesDetails'
import ComingSoon from './js/page_components/ComingSoon'
import Achievements from './js/page_components/Achievements'
import ContactForm from './js/page_components/ContactForm'
import ANCLResult from './js/page_components/ANCLResult'
import Gallery2014 from './js/page_components/Gallery2014'
import Gallery2022 from './js/page_components/Gallery2022'
import Gallery2019 from './js/page_components/Gallery2019'
import Blog1 from './js/page_components/Blog1'
import MatchesList from './js/page_components/MatchesList'
import ANCLScheduleMatches from './js/schedule_components/ANCLScheduleMatches'
import ANCL2021YearSchedule from './js/schedule_components/ANCL2021YearSchedule'
import ANCL2022YearSchedule from './js/schedule_components/ANCL2022YearSchedule'
import ANCL2023YearSchedule from './js/schedule_components/ANCL2023YearSchedule'
import Full_Match_Details from './js/match_details/Full_Match_Details'
import ScrollToTop from './js/header_components/ScrollToTop'
import ResultDetailsCarousel from './js/page_components/ResultDetailsCarousel'
import SimpleContainer from './js/Admin_Panel/SimpleContainer'
import Sponsors from './js/page_components/Sponsors'

const access_token =
  'EAALLZCZC5QQnMBPeijZAEfP1InZARTSC2FGkbDBmhbgXITKymdIWUghUV4bGIMAoZCAueSZALkiPPlg0BD6KYjafDgsjP0dtQxXAlsZAppbZBZBhQJKXIJbcPrC4ZARNYzlLOBm1iX6qzDPF8Xj7xHjwHZAxoI2qqYrloAHnTAT2c2KjPiQhBlKUcIEYfWoLR1e5SkZB'
function App() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])
  return (
    <>
      <Router>
        <Header />
        <ScrollToTop>
          <Routes>
            <Route
              path='/'
              element={
                <>
                  <Slider />
                  <SponsorsLeaderboard />
                  <ResultDetailsCarousel />
                  <MatchesList />
                  <UpcomingMatches />
                  <InstagramSlider />
                  <AboutSection />
                  <Home />
                  <Sponsors />
                </>
              }
            />
            <Route
              path='/gallery'
              element={
                <>
                  <Subheader pagetitle='Gallery' />
                  <Gallery />
                </>
              }
            />
            <Route
              path='/redzod-team'
              element={
                <>
                  <Subheader pagetitle='Redzod Team' />
                  <ANCLTeam />
                </>
              }
            />
            <Route
              path='/anclseries'
              element={
                <>
                  <Subheader pagetitle='ANCL Series' />
                  <ANCLSeries />
                </>
              }
            />
            <Route
              path='/nccauccl'
              element={
                <>
                  <Subheader pagetitle='NCCA UCL Series' />
                  <MatchesList />
                </>
              }
            />
            <Route
              path='/playerdetail/:id'
              element={
                <>
                  <Subheader pagetitle='Player Detail' />
                  <SinglePlayerDetail />
                </>
              }
            />
            <Route
              path='/leaguedetails/:sid'
              element={
                <>
                  <Subheader pagetitle='League Detail' />
                  <ANCLSeriesDetails />
                </>
              }
            />
            <Route
              path='/achievements'
              element={
                <>
                  <Subheader pagetitle='Achievements' />
                  <ComingSoon />
                  <Achievements />
                </>
              }
            />
            <Route
              path='/contact'
              element={
                <>
                  <Subheader pagetitle='Contact' />
                  <ContactForm />
                </>
              }
            />
            <Route
              path='/anclresult/:sid/:tid'
              element={
                <>
                  <Subheader pagetitle='ANCL Series Result' />
                  <ANCLResult />
                </>
              }
            />

            {/* Year galleries – ensure each path is unique */}
            <Route
              path='/2008'
              element={
                <>
                  <Subheader pagetitle='2008' />
                  <Gallery2008 />
                </>
              }
            />
            <Route
              path='/2009'
              element={
                <>
                  <Subheader pagetitle='2009' />
                  <Gallery2009 />
                </>
              }
            />
            <Route
              path='/2012'
              element={
                <>
                  <Subheader pagetitle='2012' />
                  <Gallery2012 />
                </>
              }
            />
            <Route
              path='/2013'
              element={
                <>
                  <Subheader pagetitle='2013' />
                  <Gallery2013 />
                </>
              }
            />
            <Route
              path='/2014'
              element={
                <>
                  <Subheader pagetitle='2014' />
                  <Gallery2014 />
                </>
              }
            />
            <Route
              path='/2015'
              element={
                <>
                  <Subheader pagetitle='2015' />
                  <Gallery2015 />
                </>
              }
            />
            <Route
              path='/2019'
              element={
                <>
                  <Subheader pagetitle='2019' />
                  <Gallery2019 />
                </>
              }
            />
            <Route
              path='/2022'
              element={
                <>
                  <Subheader pagetitle='2022' />
                  <Gallery2022 />
                </>
              }
            />
            {/* FIX: remove duplicate /2022; give Blog1 its own path */}
            <Route
              path='/blog/2022'
              element={
                <>
                  <Subheader pagetitle='2022' />
                  <Blog1 />
                </>
              }
            />

            {/* Schedules */}
            <Route
              path='/schedule-matches/:seriesid/:teamid'
              element={
                <>
                  <Subheader pagetitle='Schedule Matches' />
                  <ANCLScheduleMatches />
                </>
              }
            />
            <Route
              path='/2021-series-schedule/:ssy'
              element={
                <>
                  <Subheader pagetitle='2021 Schedule' />
                  <ANCL2021YearSchedule />
                </>
              }
            />
            <Route
              path='/2022-series-schedule/:ssy'
              element={
                <>
                  <Subheader pagetitle='2022 Schedule' />
                  <ANCL2022YearSchedule />
                </>
              }
            />
            <Route
              path='/2023-series-schedule/:ssy'
              element={
                <>
                  <Subheader pagetitle='2023 Schedule' />
                  <ANCL2023YearSchedule />
                </>
              }
            />
            <Route
              path='/schedule-matches/comingsoon'
              element={
                <>
                  <Subheader pagetitle='2023 Schedule' />
                  <ComingSoon />
                </>
              }
            />

            <Route
              path='/match-details/:mid/:cid'
              element={
                <>
                  <Subheader pagetitle='Match Detail' />
                  <Full_Match_Details />
                </>
              }
            />
            <Route path='/simple' element={<SimpleContainer />} />

            <Route path='*' element={<NotFound />} />
          </Routes>
          <Footer />
        </ScrollToTop>
      </Router>
    </>
  )
}

export default App
